import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Draggable from "react-draggable";

const NativePopup = ({
  children,
  className = "",
  style,
  isDraggable = true,
  isResizable = true,
  hideTrigger = false,
  initialized,
  showing,
  shown,
  hiding,
  hidden,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const hostRef = useRef(null);
  const backdropRef = useRef(null);
  const apiRef = useRef(null);

  if (!apiRef.current) {
    apiRef.current = {
      hostElement: null,
      _bkDrop: null,
      show() {
        showing?.(apiRef.current);
        setIsOpen(true);
        requestAnimationFrame(() => {
          setIsVisible(true);
          shown?.(apiRef.current);
        });
      },
      hide() {
        hiding?.(apiRef.current);
        setIsVisible(false);
        setTimeout(() => {
          setIsOpen(false);
          hidden?.(apiRef.current);
        }, 180);
      },
    };
  }

  useEffect(() => {
    initialized?.(apiRef.current);
  }, []);

  useEffect(() => {
    apiRef.current.hostElement = hostRef.current;
    apiRef.current._bkDrop = backdropRef.current;
  }, [isOpen]);

  const popup = (
    <div
      ref={backdropRef}
      className={`maxis-popup-backdrop${isOpen ? " is-open" : ""}`}
      aria-hidden={!isOpen}
      style={{ display: isOpen ? "flex" : "none" }}
      onMouseDown={(event) => {
        if (hideTrigger && event.target === event.currentTarget) {
          apiRef.current.hide();
        }
      }}
    >
      <Draggable disabled={!isDraggable} handle=".modal-header">
        <div
          ref={hostRef}
          className={`maxis-popup custom-animation ${isVisible ? "custom-animation-visible" : ""} ${className || ""}`}
          style={{
            ...style,
            resize: isResizable ? "both" : "none",
          }}
          tabIndex={-1}
          onKeyDown={(event) => {
            if (event.key === "Escape") event.preventDefault();
          }}
        >
          {children}
        </div>
      </Draggable>
    </div>
  );

  return createPortal(popup, document.body);
};

export default NativePopup;
